import React from 'react'
import { ResponsivePie } from '@nivo/pie'
import withWidth from '@material-ui/core/withWidth';
import colors from '../../constants/colors'

import {
  capitalize,
  format_number
 } from '../../helpers'

class Pie extends React.Component {
  // props:
  // data: server sent it to me :)
  // THIS could posibly rotate all
// document.querySelectorAll('.instalevel-pie-chart g[transform*="translate("][transform*=",0)"]').
//
  // componentDidUpdate(prevProps, prevState) {
  //   if ( prevProps.width !== this.props.width ) {
  //     this.fixlegends()
  //   }
  // }

  componentWillMount() {
    this.fixlegends()
  }

  fixlegends() {
    setTimeout( function(self) {
      const { graphData, width, id } = self.props
      const threshold = (width === 'xs' || width === 'sm') ? 3 : 4
      if ( graphData.length > threshold ) {
        let multiplier = parseInt( (graphData.length - 1 ) / threshold, 10 ) + 1
        document.querySelectorAll(`#${id} g[transform*="translate("][transform*=",0)"]`).forEach( (item, i) => {
          if ( i % threshold === 0 ) {
            multiplier = multiplier - 1
          }
          const offset = (i % threshold) * 80
          const height = -20 * multiplier
          item.setAttribute('transform', `translate(${offset},${height})`)
        })
      }
    }, 500, this)
  }

  render() {
    const data = this.props.graphData
    const {variant, skipBlanks, forceFirstColors } = this.props

    let total = data.length > 0 ? data.map( a=> a.count ).reduce( (a, b) => a + b) : 1;
    total = total === 0 ? 1 : total
    const graph_data = (skipBlanks ? data.filter(d => d.count > 0) : data).map( item => {
      return {
        id: capitalize(item.label),
        label: capitalize(item.label),
        value: item.count
      }
    })

    const sliceLabel = item => {
      const valueTag = this.props.valueTag ? `${this.props.valueTag} ` : ''
      if (variant === 'percent') {
        return `${Math.round(item.value * 100 / total)} %`
      } else if (variant === 'thousands') {
        return `${valueTag}${Math.round(item.value/100)/10}k`
      } else {
        if (valueTag === '') {
          return format_number(item.value, false)
        } else {
          return `${valueTag}${format_number(item.value)}`
        }
      }
    }

    // const colorMatch = {
    //   'Coupon': '#1d78b4',
    //   'Fully Paid': '#a6cee3',
    //   'Published': '#c6dbef',
    //   'Draft': '#deebf7',
    //   'Trashed': '#f7fbff"'
    // }
    const colorMatch = {
      'Coupon': '#9467bd',
      'Fully Paid': '#1f77b4',
      'Published': '#2ea02c',
      'All': '#2ea02c',
      'Draft': '#7f7f7f',
      'Trashed': '#d62728"'
    }

    const tooltip = item => {
      let total = 1
      if (this.props.variant === 'number_to_percent') {
        const data = this.props.graphData
        total = data.length > 0 ? data.map( a=> a.count ).reduce( (a, b) => a + b) : 1;
        total = total === 0 ? 1 : total
      }

      const {value, label, color} = item
      const valueTag = this.props.valueTag ? `${this.props.valueTag} ` : ''
      const displayValue = this.props.decimals ? format_number(value) : format_number(value, false)
      const finalValue = this.props.variant === 'number_to_percent' ? `${Math.round(item.value * 100 / total)} %` : `${valueTag}${displayValue}`
      const useColor = colorMatch[label] || color
      return (
        <div className="custom-pie-tooltip-inner">
          <span className="custom-pie-tooltip-first" style={{background: `${useColor} none repeat scroll 0% 0%`}}/>
          <span>{label}: <strong>{finalValue}</strong></span>
        </div>
      )
    }

    return(
      <ResponsivePie
        data={graph_data}
        margin={{
          "top": 40,
          "right": 24,
          "bottom": 60,
          "left": 24
        }}
        innerRadius={0.5}
        padAngle={1}
        cornerRadius={5}
        tooltip={tooltip}
        colors={forceFirstColors ? [...forceFirstColors, ...colors] : colors}
        colorBy="label"
        borderWidth={2}
        borderColor="inherit:darker(0.4)"
        enableRadialLabels={false}
        slicesLabelsSkipAngle={0}
        slicesLabelsTextColor={ "#ffffff" ||  this.props.color === 'bright' ? "#ffffff" : "#333333" }
        sliceLabel={ l => sliceLabel(l) }
        animate={true}
        motionStiffness={90}
        motionDamping={15}
        defs={[
          {
            "id": "published",
            "type": "patternDots",
            "background": "#2ea02c",
            "color": "#2ea02c",
            "size": 4,
            "padding": 1,
            "stagger": true
          },
          {
            "id": "draft",
            "type": "patternDots",
            "background": "#7f7f7f",
            "color": "#7f7f7f",
            "size": 4,
            "padding": 1,
            "stagger": true
          },
          {
            "id": "trash",
            "type": "patternDots",
            "background": "#d62728",
            "color": "#d62728",
            "size": 4,
            "padding": 1,
            "stagger": true
          },
          {
            "id": "paid",
            "type": "patternDots",
            "background": "#1f77b4",
            "color": "#1f77b4",
            "size": 4,
            "padding": 1,
            "stagger": true
          },
          {
            "id": "coupons",
            "type": "patternDots",
            "background": "#9467bd",
            "color": "#9467bd",
            "size": 4,
            "padding": 1,
            "stagger": true
          },
        ]}
        fill={[
          {
            "match": {
              "id": "Published"
            },
            "id": "published"
          },
          {
            "match": {
              "id": "Draft"
            },
            "id": "draft"
          },
          {
            "match": {
              "id": "Trash"
            },
            "id": "trash"
          },
          {
            "match": {
              "id": "Trashed"
            },
            "id": "trash"
          },
          {
            "match": { "id": "Coupon" },
            "id": "coupons"
          },
          {
            "match": { "id": "Fully Paid" },
            "id": "paid"
          },
        ]}
        legends={[{
          "anchor": "bottom-left",
          "direction": "row",
          "justify": false,
          "translateY": 60,
          "itemsSpacing": 10,
          "itemWidth": 80,
          "itemHeight": 14,
          "symbolSize": 12,
          "symbolShape": "circle",
          "effects": [
            {
              "on": "hover",
              "style": {
                "itemBackground": "rgba(0, 0, 0, .03)",
                "itemOpacity": 1
              }
            }
          ]
        }]}
      />
    )
  }
}

export default withWidth()(Pie)



// WEBPACK FOOTER //
// ./src/js/components/graphs/ResponsivePie.js